/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForIncorrectRequestsResponseIncorrectRequestElements
 */
export interface ReportForIncorrectRequestsResponseIncorrectRequestElements {
    /**
     * 
     * @type {string}
     * @memberof ReportForIncorrectRequestsResponseIncorrectRequestElements
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ReportForIncorrectRequestsResponseIncorrectRequestElements
     */
    date: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsResponseIncorrectRequestElements
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof ReportForIncorrectRequestsResponseIncorrectRequestElements
     */
    message: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForIncorrectRequestsResponseIncorrectRequestElements
     */
    request: string | null;
}

export function ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSON(json: any): ReportForIncorrectRequestsResponseIncorrectRequestElements {
    return ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSONTyped(json, false);
}

export function ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForIncorrectRequestsResponseIncorrectRequestElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (json['date'] === null ? null : new Date(json['date'])),
        'code': json['code'],
        'message': json['message'],
        'request': json['request'],
    };
}

export function ReportForIncorrectRequestsResponseIncorrectRequestElementsToJSON(value?: ReportForIncorrectRequestsResponseIncorrectRequestElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date === null ? null : value.date.toISOString()),
        'code': value.code,
        'message': value.message,
        'request': value.request,
    };
}

